export default __webpack_public_path__ + "static/gabrielwong2-ca9c6022f49f392b65da79e218171a12.png";